import React, { Component } from 'react';
import {Subtopic, TextHolder, Footer,Highchartscomponent, Button} from '../../Components/contentHolders/contentHolders.js';
import './styles.css';
import Highcharts from 'highcharts';



Highcharts.setOptions({
colors: ['#660066', '#800080', '#be29ec', '#d896ff', '#efbbff',
    '#FDB9C8', '#DE6FA1', '#FB607F', '#DE3163', '#F81894']
});



const training = {
  chart: {
        type: 'column'
    },
    title: {
        text: ''
    },
    xAxis: {
        categories: ['Business', 'Technology (e.g. Computer Science, AI)','Engineering / math', 'Arts (e.g. literature, music)', 'Physical sciences', 'Arts (e.g. literature, music)', 'Social sciences', 'Other']
    },
    yAxis: {
        min: 0,
        title: {
            text: '% of responses'
        }
    },
    legend: {
        reversed: true
    },
    plotOptions: {
        series: {
            stacking: 'normal'
        }
    },
    series: [ {
        name: 'Academic training',
        data: [41, 20 ,14, 8,6,4,7]
    }]
}



const survey4 = {
  chart: {
        type: 'bar'
    },
    title: {
        text: ''
    },
    xAxis: {
        categories: ['Community builder', 'Founder', 'VC/Investor']
    },
    yAxis: {
        min: 0,
        title: {
            text: '% of responses by population type'
        }
    },
    legend: {
        reversed: true
    },
    plotOptions: {
        series: {
            stacking: 'percent'
        }
    },
    series: [{
        name: 'Somewhat of an disadvantage',
        data: [6, 2, 0]
    },{
        name: 'Neutral',
        data: [7, 12, 4]
    },{
        name: 'Somewhat of an advantage',
        data: [31, 47, 58]
    },{
        name: 'Significant advantage',
        data: [56, 39, 38]
    }]
}



const survey3 = {
  chart: {
        type: 'bar'
    },
    title: {
        text: ''
    },
    xAxis: {
        categories: ['Community builder', 'Founder', 'VC/Investor']
    },
    yAxis: {
        min: 0,
        title: {
            text: '% of responses by population type'
        }
    },
    legend: {
        reversed: true
    },
    plotOptions: {
        series: {
            stacking: 'percent'
        }
    },
    series: [{
        name: 'Significant disadvantage',
        data: [6, 4, 0]
    },{
        name: 'Somewhat of an disadvantage',
        data: [0, 2, 0]
    },{
        name: 'Neutral',
        data: [6, 10, 19]
    },{
        name: 'Somewhat of an advantage',
        data: [50, 41, 50]
    },{
        name: 'Significant advantage',
        data: [38, 43, 31]
    }]
}

const turtles = {
  chart: {
      type: 'column'
  },
  title: {
      text: ''
  },
  xAxis: {
      categories: ['VC/Investor', 'Founder', 'Community builder']
  },
  yAxis: {
      min: 0,
      title: {
          text: '% of responses'
      }
  },
  tooltip: {
      pointFormat: '<span style="color:{series.color}">{series.name}</span>: <b>{point.y}</b> ({point.percentage:.0f}%)<br/>',
      shared: true
  },
  plotOptions: {
      column: {
          stacking: 'percent'
      }
  },
  series: [{
      name: 'Yes',
      data: [65, 72, 63]
    },
      {
      name: 'No',
      data: [31, 26, 38]
    },
      {
      name: 'Prefer not to respond',
      data: [4, 0, 0]
    }]
}


const region = {
  chart: {
      type: 'column'
  },
  title: {
      text: ''
  },
  xAxis: {
      categories: ['VC/Investor', 'Founder', 'Community builder']
  },
  yAxis: {
      min: 0,
      title: {
          text: '% of responses'
      }
  },
  tooltip: {
      pointFormat: '<span style="color:{series.color}">{series.name}</span>: <b>{point.y}</b> ({point.percentage:.0f}%)<br/>',
      shared: true
  },
  plotOptions: {
      column: {
          stacking: 'percent'
      }
  },
  series: [{
      name: 'Yes',
      data: [76, 46, 60]
    },
      {
      name: 'No',
      data: [24, 54, 40]
    }]
}

const region2 = {
  chart: {
      type: 'column'
  },
  title: {
      text: ''
  },
  xAxis: {
      categories: ['VC/Investor', 'Founder', 'Community builder']
  },
  yAxis: {
      min: 0,
      title: {
          text: '% of responses'
      }
  },
  tooltip: {
      pointFormat: '<span style="color:{series.color}">{series.name}</span>: <b>{point.y}</b> ({point.percentage:.0f}%)<br/>',
      shared: true
  },
  plotOptions: {
      column: {
          stacking: 'percent'
      }
  },
  series: [{
      name: '15+ years',
      data: [8, 11, 17]
    },
      {
      name: '11-15 years',
      data: [15, 0, 0]
    },
      {
      name: '6-10 years',
      data: [0, 26, 0]
    },
      {
      name: '1-5 years',
      data: [77, 56, 83]
    },
      {
      name: 'Less than 1 year',
      data: [0, 5, 0]
    }]
}



export class ChapterSixtyTwo extends Component {

  render() {
    return (

      <section className="Content">
        <div className="content-holder">
        <div className="content-holder-inner fade">


        <Subtopic subtopicNumber={ this.props.number } subtopicTitle={ this.props.name } >

        {""}
        </Subtopic>

        <TextHolder text="Most of the founders we surveyed were born or raised in SEA but educated abroad. In SEA it’s widely believed that these “sea turtles” (returnees from abroad) have a key role to play in the startup ecosystem in SEA. By applying the knowledge they gained in more developed mature startup hubs like Silicon Valley, they may help kickstart the tech economy at home." />
        <TextHolder text="The high number of “sea turtles” among our founders supports that hypothesis. Over 80 percent of respondents believe that both “sea turtle” tech founders and employees have an advantage over locals without international experience." />
        <TextHolder text="Most investors and community builders who responded to our survey had been educated abroad as well. Of the many respondents who had spent time abroad, most were gone for no more than 5 years and returned within at least the last 10 years." />
        <TextHolder text="This suggests that international experience may be vital for founders, given the business connections and experiences that time abroad offers. But as the ecosystem continues to mature, there will be less need to go outside of the region to find this experience; startups and tech employees will be able to gain industry knowledge, both regionally and internationally, from local experienced entrepreneurs, VCs and community builders." />
        <TextHolder text="A. Balasubramaniam of MDEC observed that time abroad may expose “sea turtles” to new ways of thinking. “Not only does cultural immersion give them a new mindset and mindshare, but it helps them challenge the status quo back home,” he said." />
        <TextHolder text="“Being abroad opens up the mind and establishes relevant and useful networks - especially for ‘sea turtles,’” added Umar Munshi, co-founder of Ethis Ventures and Ethis Crowd. “But, there is no ideal profile of a successful tech founder in Southeast Asia. I believe that local-bred founders will catch up and co-lead tech in SEA.”" />
        <TextHolder text="Bambu founder and CEO Ned Phillips agreed that the playing field is open for founders of varying backgrounds. “A successful tech founder in SEA needs to have relentless positivity and strong sales. Plain and simple,” he said." />

        <TextHolder text="" />


        <Highchartscomponent  chartsText="Were you born in and/or grew up in SE Asia?" options={turtles}  source="Source: 2018 State of SE Asian Tech Survey" />

        <Highchartscomponent  chartsText="What is your academic training in?"
         options={training} source="Source: 2018 State of SE Asian Tech Survey" />

        <Highchartscomponent  chartsText="Have you ever left the region to  pursue your education or career abroad?" options={region}  source="Source: 2018 State of SE Asian Tech Survey" />

        <Highchartscomponent  chartsText="If yes, how many years were you away?" options={region2}  source="Source: 2018 State of SE Asian Tech Survey" />



        <Highchartscomponent chartsText="How do 'sea turtles' compare to local SEA FOUNDERS without international experience?"
          options={survey3} source="Source: 2018 State of SE Asian Tech Survey" />
          <Highchartscomponent chartsText="How do 'sea turtles' compare to local TECH EMPLOYEES without international experience?"
            options={survey4} source="Source: 2018 State of SE Asian Tech Survey" />







          <Button next={ this.props.next } buttonText= { this.props.buttonText } />
          <Footer />
          </div>
        </div>
      </section>

    );
  }
}



// WEBPACK FOOTER //
// ./src/Containers/Content/62.js